const advertisement = function () {
	// Ads - show one random ad

	const headerrandom = Math.floor(
		Math.random() * $('.headerAdContainer .singleAdHolder').length
	);
	$('.headerAdContainer .singleAdHolder ').hide().eq(headerrandom).show();

	const numberOfAds = $('.SidebarAdContainer .singleAdHolder').length;
	const numSideAds = $('.sidebarAdMargin').data('ads');

	// If the number of desired ads is greater than the number of available ads, default to showing a single random ad.
	if (numSideAds > numberOfAds) {
		const sidebarrandom = Math.floor(
			Math.random() * $('.SidebarAdContainer .singleAdHolder').length
		);
		$('.SidebarAdContainer .singleAdHolder ')
			.hide()
			.eq(sidebarrandom)
			.show();
	} else {
		// If the number of available ads is greater than the number of ads we should display (x), display (x) number of random ads.
		const limit = numberOfAds;
		const desiredAmountOfAds = numSideAds;

		// build an array to contain unique, random numbers
		const arr = [];
		while (arr.length < desiredAmountOfAds) {
			const randomNumber = Math.ceil(Math.random() * limit);
			let found = false;
			for (let i = 0; i < arr.length; i++) {
				if (parseInt(arr[i]) === randomNumber) {
					found = true;
					break;
				}
			}
			if (!found) arr[arr.length] = randomNumber;
		}
		$('.SidebarAdContainer .singleAdHolder ').hide();

		// Cycle through our array of unique, random numbers to display only those ads.
		for (let j = 0; j < arr.length; j++) {
			$('.SidebarAdContainer .ad-number-' + arr[j] + '').show();
		}
	}

	const footerrandom = Math.floor(
		Math.random() * $('.footerAdContainer .singleAdHolder').length
	);
	$('.footerAdContainer .singleAdHolder').hide().eq(footerrandom).show();
};

export default advertisement;
